import { Nav1 } from "./Nav1";
import { Nav2 } from "./Nav2";

export const Navbar = () => {
    return <>
        <Nav1 />
        <Nav2 />
    </>
}